import { useGetDestinationIbans } from "../../lib/queries/queriesAndMutations";
import Popup from "reactjs-popup";
import SavedIbanCart from "./SavedIbanCart";
import SavedIbanForm from "../forms/SavedIbanForm";
import { useCallback, useState } from "react";
import Pagination from "../../shared/Pagination";
import icons from "../../lib/icons";

const IbanNote = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 20;
  const onPageChange = useCallback((page) => setCurrentPage(page), []);

  const { data: destinations, refetch } = useGetDestinationIbans({
    currentPage,
    debouncedQueryParams: {},
  });

  return (
    <>
      {!destinations?.count ? (
        <div className=" flex items-center p-6 rounded-md gap-2">
          <img
            src="/images/bankcard.svg"
            alt="no saved ibans"
            className="max-w-[40px] max-h-[40px]"
          />
          <p>شماره شبای ذخیره شده ای برای شما ثبت نشده است!</p>
        </div>
      ) : (
        <>
          <div className="flex gap-1 overflow-x-scroll vanda">
            {destinations.results.map((item) => (
              <SavedIbanCart key={item.id} savedIban={item} />
            ))}
          </div>
          <div className="w-full bg-neutral-10 rounded-v-lg mt-2">
            <Pagination
              onPageChange={onPageChange}
              totalCount={destinations.count}
              siblingCount={1}
              currentPage={currentPage}
              pageSize={pageSize}
              className="bg-neutral-10"
            />
          </div>
        </>
      )}

      <Popup
        trigger={
          <button className="btn-edit flex items-center gap-1 mr-auto">
            <p>حساب جدید</p>
            <img
              src={icons.plus}
              alt="edit-icon"
              className="invert"
              width={16}
              height={16}
            />
          </button>
        }
        modal
        nested
      >
        {(close) => (
          <SavedIbanForm formType={"create"} close={close} refetch={refetch} />
        )}
      </Popup>
    </>
  );
};

export default IbanNote;
